import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ExportPackageModel } from '@app/catalog';
import { PresenterType } from '@app/shared';

@PresenterType({
  model: ExportPackageModel,
  key: "title",
})
@Component({
  selector: 'export-header',
  standalone: false,
  templateUrl: './export-header.component.html',
  styleUrl: './export-header.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ExportHeaderComponent {

}
